import React, { Component } from 'react';
import {Nav,NavItem} from 'react-bootstrap';
import './Main.css'
import Alert from 'react-s-alert';
import _tabA from './_tabA';

export default class Home extends Component {
    state = {
        navACKey : "0" ,
        showResults : 0,
        isHidden: true,
        itemcode:"",
        olditemcode:"",
        THname:"",
        ENname:"",
        data1:"",
        dataunit:"",
    }

    AlertPopup=(type,text)=>{
        switch (type) {
            case 'Warning': Alert.warning(text, {position: 'bottom-right',effect: 'slide',onShow: function () {},beep: false,timeout: 2000,offset: 0});break;
            case 'Info': Alert.info(text, {position: 'bottom-right',effect: 'slide',onShow: function () {},beep: false,timeout: 2000,offset: 0});break;
            case 'Error': Alert.error(text, {position: 'bottom-right',effect: 'slide',onShow: function () {},beep: false,timeout: 2000,offset: 0});break;
            case 'Success': Alert.success(text, {position: 'bottom-right',effect: 'slide',onShow: function () {},beep: false,timeout: 2000,offset: 0});break;
            default: Alert.closeAll(); break;
        }
    }
    
    onSave = (value) =>{
        if(this.state.itemcode === "" || this.state.data1 === ""){
            this.AlertPopup("Error","บันทึกไม่สำเร็จ!");
        }else{
            const parameter = new URLSearchParams();
            parameter.append("user",localStorage.getItem("Username"));
            parameter.append("saleno",this.state.products[value].Stockno);
            parameter.append("refno",this.state.products[value].Refno);
            parameter.append("customercode",this.state.products[value].Customercode);
            parameter.append("taxid",this.state.products[value].Taxinvoice);
            parameter.append("contractdate",this.state.products[value].Contractdate);
            parameter.append("price",this.state.products[value].Price);
            parameter.append("hploannet",this.state.products[value].Priceloannet);
        }
    }

    inputonChange = (type,value) =>{
        switch (type) {
            case "itemcode":this.setState({itemcode:value.target.value});break;
            case "olditemcode":this.setState({olditemcode:value.target.value});break;
            case "THname":this.setState({THname:value.target.value});break;
            case "ENname":this.setState({ENname:value.target.value});break;
            default : break;
        }
    } 
    Getdata = (from,value) => {
        switch (from) {
            case "dataunit": this.setState({dataunit:value}); break; 
        }
       setTimeout(() => {console.log(this.state.dataunit);}, 50);
    } 
    handleSelect(eventKey) {
        this.setState({navACKey:eventKey,showResults:eventKey});
        if(this.state.eventKey === 0 ){
            this.setState({isHidden: true});
        }else{
            this.setState({isHidden: false});
        }
    } 
    render() {
        return (
            <div class="">
                <Alert stack={{limit: 1}} />
                <nav class="navbar TopApp">
                    <div class="flex-list">
                        <ul class="nav navbar-nav navbar-left">
                        <li onClick={this.onSave}><button type="button" class="btn btn-xs glyphicon glyphicon-floppy-disk" tabIndex="21"> บันทึก</button></li>
                        <li><button type="button" class="btn btn-xs glyphicon glyphicon-file" tabIndex="22"> ใหม่</button></li>
                        <li><button type="button" class="btn btn-xs glyphicon glyphicon-trash" tabIndex="23"> ลบ</button></li>
                        <span className="pipe"></span>
                        <li><button type="button" class="btn btn-xs glyphicon glyphicon-print" tabIndex="24"> พิมพ์</button></li>
                        <li><button type="button" class="btn btn-xs glyphicon glyphicon-log-out" onClick={()=>{window.location.href = 'home'}} tabIndex="25"></button></li>
                    </ul>
                    </div>
                </nav>
               <div class="container">
                <div class="container-fluid col-xs-12 col-sm-12  col-md-12 col-lg-6">
                    <hr/> 
                    <div class="row">
                    <div class="form-group col-xs-12 col-sm-6 col-lg-6 col-md-6">
                            <div class="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                   <span class="input-group-addon">รหัสสินค้า : </span>
                                   <input id="itemcode" type="text" class="form-control " name="itemcode" onChange={this.inputonChange.bind(null,"itemcode")} tabIndex="1"/>
                                   
                            </div>
                    </div>
                    <div class="form-group col-xs-12 col-sm-6 col-lg-6 col-md-6">
                    <div class="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                           <span class="input-group-addon">รหัสสินค้าเก่า : </span>
                           <input id="olditemcode" type="text" class="form-control " name="olditemcode" onChange={this.inputonChange.bind(null,"olditemcode")}tabIndex="2" />
                            
                    </div>
                    </div>
                    <div class="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div class="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                            <span class="input-group-addon"> ชื่อสินค้าภาษาไทย :</span>
                            <input   id="id1" type="text" class="form-control " onChange={this.inputonChange.bind(null,"THname")} tabIndex="3"/>    
                        </div>
                    </div>
                    </div>  
                </div>
                <div class="clearfix"></div>
                    <Nav  bsStyle="tabs" activeKey={this.state.navACKey} className="Inventory" onSelect={k => this.handleSelect(k)}>
                        <NavItem eventKey="0" >ข้อมูล</NavItem>
                        <NavItem eventKey="1" >หน่วยนับ</NavItem>
                        <NavItem eventKey="2" >คลังสินค้า</NavItem>
                        <NavItem eventKey="3" >บาร์โค้ด</NavItem> 
                        <NavItem eventKey="4" >สินค้าชุด</NavItem> 
                    </Nav>
                    <div>
                        <_tabA Inventory={this.state} Getdata={this.Getdata}/>
                    </div>
                </div>
            </div>
        )
    }
}










































